import { User } from "../../models/user";
import * as FetchUtil from "../fetch-util";

export class UsersService {
  static getUser(userId: string): Promise<FetchUtil.HttpResponse<User>> {
    return FetchUtil.get(`/api/v1/users/${userId}`);
  }
  static getCurrentUser(): Promise<FetchUtil.HttpResponse<User>> {
    return FetchUtil.get(`/api/v1/users/0`);
  }
}
